module.exports = __webpack_public_path__ + "static/populace.b561068f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/populace.svg
// module id = 484
// module chunks = 35783957827783